import {SET_CURRENT_PAGE} from "../reducers/userContext";

export const setCurrentPage = (page) => {
    return {
        type: SET_CURRENT_PAGE,
        page
    }
}
